
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { AuthService } from "@/services/auth-service";
import { Tier } from "@/utils/payments/tiers";
import { SignatureSettings } from "@/utils/sale-layouts/signature-settings";
import { SaleLayoutTotalLines } from "@/utils/sale-layouts/total-lines";
import AppSelectPlacement from "./SelectPlacement.vue";
import Vue from "vue";
import { SaleLayoutLogoPosition } from "@/utils/sale-layouts/logo";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import { MODULE } from "@/config/modules";
import AppStyleEditor from "../layout-editor/StyleEditor.vue";
import { TextStyledProperty } from "@/utils/documents/text-styled-property";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			selectedLanguage: "nl-be",
			ogmTextFocused: false,
			tab: 0,
			toEditGrandTotalStyle: null as null | TextStyledProperty,
			toEditTotalStyle: null as null | TextStyledProperty,
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	computed: {
		lines():SaleLayoutTotalLines{
			return this.layout.TotalLines;
		},
		signature():SignatureSettings{
			return this.layout.SignatureSettings;
		},
		canPrintOgm(): boolean {
			if (AuthService.isDevModeEnabled) {
				return true;
			}
			return AuthService.wfCompany.Tier >= Tier.ENTERPRISE || (AuthService.wfCompany.Tier == Tier.PROFESSIONAL && AuthService.hasModule(MODULE.LINK_MET_ISABEL));
		},
		ogmText(): string {
			let text = this.lines.OgmText.getTranslation(this.selectedLanguage);
			if (this.ogmTextFocused) {
				return text;
			}
			if (text == "") {
				return this.defaultOgmText;
			}
			return text;
		},
		defaultOgmText(): string {
			return "Gelieve deze gestructureerde mededeling te gebruiken bij de betaling: %OGM%";
		},
		tabs(): any {
			return Object.values(this.$ct("total-line-tabs"));
		},
		signaturePlacement():SaleLayoutLogoPosition {
			if (!this.signature.Show) {
				return "null";
			}
			return this.signature.Placement;
		},
		signaturePlacementDisabled():boolean {
			if (this.signaturePlacement != "null") {
				return false;
			}
			return !AuthService.hasModule(MODULE.DIGITALE_HANDTEKENING);
		},
		extraActions():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("total-style-edit"),
					value: this.editTotalStyle
				},
				{
					text: this.$ct("reset-total-style"),
					value: this.resetTotalStyle
				},
				{
					text: this.$ct("grand-total-style-edit"),
					value: this.editGrandTotalStyle
				},
				{
					text: this.$ct("reset-grand-total-style"),
					value: this.resetGrandTotalStyle
				},

			];
		}
	},
	methods: {
		setOgmText(value: string) {
			this.lines.OgmText.Translations[this.selectedLanguage] = value;
		},
		onOgmTextBlur() {
			this.ogmTextFocused = false;
			if (this.lines.OgmText.getTranslation(this.selectedLanguage) == "") {
				this.setOgmText(this.defaultOgmText);
			}
		},
		setSignaturePlacement(value:SaleLayoutLogoPosition) {
			if (value == "null") {
				this.signature.Show = false;
			}else{
				this.signature.Show = true;
				this.signature.Placement = value;
			}
		},
		editGrandTotalStyle(){
			this.toEditGrandTotalStyle = this.layout.TotalLines.GrandTotalLineStyleOverride;
		},
		onGrandTotalStyle(style:TextStyledProperty){
			this.layout.TotalLines.UseGrandTotalLineStyleOverride = true;
			this.layout.TotalLines.GrandTotalLineStyleOverride = style;
		},
		async resetGrandTotalStyle(){
			let confirm = await this.$confirmBuilder(this.$ct("confirm-reset-grand-total-style")).setWarningTitle().show();
			if (!confirm) return;
			this.layout.TotalLines.GrandTotalLineStyleOverride = SaleLayoutTotalLines.getDefaultGrandTotalLineStyle();
			this.layout.TotalLines.UseGrandTotalLineStyleOverride = false;
		},
		editTotalStyle(){
			this.toEditTotalStyle = this.layout.TotalLines.TotalLineStyleOverride;
		},
		onTotalStyle(style:TextStyledProperty){
			this.layout.TotalLines.UseTotalLineStyleOverride = true;
			this.layout.TotalLines.TotalLineStyleOverride = style;;
		},
		async resetTotalStyle(){
			let confirm = await this.$confirmBuilder(this.$ct("confirm-reset-total-style")).setWarningTitle().show();
			if (!confirm) return;
			this.layout.TotalLines.TotalLineStyleOverride = SaleLayoutTotalLines.getDefaultTotalLineStyle();
			this.layout.TotalLines.UseTotalLineStyleOverride = false;
		},
	},
	components: {
		AppCustomLanguageSelect,
		AppSelectPlacement,
		AppStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
